import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const SalesTabPC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <nav className="funeral-methods-content-navigation sales-tab-pc">
            <div className="funeral-methods-content-nav-container">
                <ul>
                    <li><a className={`${pathname === '/sky-special-room' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/sky-special-room'); }}>하늘관 특별실</a></li>
                    <li><a className={`${pathname === '/sky-hall-phoenix-room' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/sky-hall-phoenix-room'); }}>하늘관 봉황실</a></li>
                    <li><a className={`${pathname === '/sky-hall-vip-sales' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/sky-hall-vip-sales'); }}>하늘관 VIP</a></li>
                    <li><a className={`${pathname === '/star-hall-sales' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/star-hall-sales'); }}>별빛관</a></li>
                    <li><a className={`${pathname === '/sunlight-hall-sales' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/sunlight-hall-sales'); }}>햇빛관</a></li>
                    <li><a className={`${pathname === '/s-hall-sales' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/s-hall-sales'); }}>S관</a></li>
                    <li><a className={`${pathname === '/outdoor-hall-sales' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/outdoor-hall-sales'); }}>야외 봉안당</a></li>
                </ul>
            </div>
        </nav>
    );
};

export default SalesTabPC;